<nav class="flex flex-col h-full w-44 border-r border-gray-200 pr-3 gap-1">
  @for (item of items(); track item.value) {
    <button (click)="valueChange.emit(item.value)" [class]="itemClass(item.value)">
      {{ item.label | translate }}
    </button>
  }
</nav>
